document.addEventListener("DOMContentLoaded", () => {
  // Mobile Menu Flag
  $(".navegacion .maincountry .maincountryset.countrybg").click(function () {
    $('.countyblock-mobile').toggle();
  });

  //Desktop Flag
  $("header .maincountry").mouseenter(function () {
    $('header .countyblock').addClass('c_block');
    $('header .maincountryset').addClass('up-arrow');
  }).mouseleave(function() {
      $('header .countyblock').removeClass('c_block');
      $('header .maincountryset').removeClass('up-arrow');
  });

  if ($(window).width() <= 991) {
    $("footer .maincountryset").click(function () {
      $('footer .countyblock').addClass('c_block');
      $('footer .maincountryset').addClass('up-arrow');
    })
  } else {
    $("footer .maincountry").mouseenter(function () {
      $('footer .countyblock').addClass('c_block');
      $('footer .maincountryset').addClass('up-arrow');
    }).mouseleave(function() {
        $('footer .countyblock').removeClass('c_block');
        $('footer .maincountryset').removeClass('up-arrow');
    });
  }

  //Desktop Megamenu
  /* $("ul.list-menu.list-menu--inline li:first-child").mouseenter(function() {
      jQuery('#Details-HeaderMenu-1').attr("open","open");
  }).mouseleave(function() {
      jQuery('#Details-HeaderMenu-1').removeAttr("open");
  }); */
  /* $(".list-menu li.menu").hover(
    function () {
      $(this).find('.sub-menu').toggle();
    },
    function () {
      $('.sub-menu').hide();
    },
  ); */
  
    // Mobile Menu jQuery
    $('#button-menu').click(function () {
        if ($('#button-menu').attr('class') == 'fi fi-rr-bars-staggered') {

            $('.navegacion').css({ 'width': '100%', 'background': 'rgba(0,0,0,.5)' }); // Mostramos al fondo transparente
            $('#button-menu').removeClass('fi fi-rr-bars-staggered').addClass('fi fi-rr-circle-xmark'); // Agregamos el icono X
            $('.navegacion .menu').css({ 'left': '0px' }); // Mostramos el menu

        } else {

            $('.navegacion').css({ 'width': '0%', 'background': 'rgba(0,0,0,.0)' }); // Ocultamos el fonto transparente
            $('#button-menu').removeClass('fi fi-rr-circle-xmark').addClass('fi fi-rr-bars-staggered'); // Agregamos el icono del Menu
            $('.navegacion .submenu').css({ 'left': '-320px' }); // Ocultamos los submenus
            $('.navegacion .menu').css({ 'left': '-320px' }); // Ocultamos el Menu

        }
    });
    $('#button-menuNew').click(function () {
        if ($('#button-menuNew').attr('class') == 'header__mobile__hamburger button-menuNew') {

            $('.navegacion').css({ 'width': '100%', 'background': 'rgba(0,0,0,.5)' }); // Mostramos al fondo transparente
            $('#button-menuNew').addClass('menu-active'); // Agregamos el icono X
            $('.navbar-mobile').addClass('active'); // Agregamos el icono X
            $('.navegacion .menu').css({ 'left': '0px' }); // Mostramos el menu

        } else {

            $('.navegacion').css({ 'width': '0%', 'background': 'rgba(0,0,0,.0)' }); // Ocultamos el fonto transparente
            $('#button-menuNew').removeClass('menu-active'); // Agregamos el icono del Menu
            $('.navbar-mobile').removeClass('active'); // Agregamos el icono del Menu
            $('.navegacion .submenu').css({ 'left': '-320px' }); // Ocultamos los submenus
            $('.navegacion .menu').css({ 'left': '-320px' }); // Ocultamos el Menu

        }
    });
    $('.go-back').click(function(){
        $('.navegacion .submenu').css({ 'left': '-320px' }); // Ocultamos los submenus
    })


    // Open popup video
    $(document).ready(function() {
      $('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
          disableOn: 700,
          type: 'iframe',
          mainClass: 'mfp-fade',
          removalDelay: 160,
          preloader: false,
    
          fixedContentPos: false
      });
    });

    // MOSTRANDO SUBMENU
    $('.navegacion .menu > .item-submenu a').click(function () {
        var positionMenu = $(this).parent().attr('menu'); // Buscamos el valor del atributo menu y lo guardamos en una variable
        console.log(positionMenu);
        $(this).parent().find('.submenu').css({ 'left': '0px' });
        //$('.item-submenu[menu=' + positionMenu + '] .submenu').css({ 'left': '0px' }); // Mostramos El submenu correspondiente
    });
    // OCULTANDO SUBMENU
    $('.navegacion .submenu li.go-back').click(function () {      
        $(this).parent().css({ 'left': '-320px' }); // Ocultamos el submenu
    });


    // Scroll Header jQuery

    $(window).scroll(function () {
        if ($(window).scrollTop() >= 39) {
            $('header').addClass('fixed-header');
        }
        else {
            $('header').removeClass('fixed-header');
        }
    });


    // Select Country Options

    $(".selected").on("click", function () {
        var hasActiveClass = $(".select-box").hasClass("active");

        if (hasActiveClass === false) {
            var windowHeight = $(window).outerHeight();
            var dropdownPosition = $(this).offset().top;
            var dropdownHeight = 95; // dropdown height

            if (dropdownPosition + dropdownHeight + 50 > windowHeight) {
                $(".select-box").addClass("drop-up");
            } else {
                $(".select-box").removeClass("drop-up");
            }

            var currentUniversity = $(this).find('text').text().trim();

            $.each($(".select-list li"), function () {
                var university = $(this).text().trim();
                if (university === currentUniversity)
                    $(this).addClass("active");
                else
                    $(this).removeClass("active");
            });
        }

        $(".select-box").toggleClass("active");
    });
    $(".select-list li").on("click", function () {
        var university = $(this).html();
        $("span.text").html(university);
        $(".select-box").removeClass("active");
    });
    $(".select-list li").hover(function () {
        $(".select-list li").removeClass("active");
    });
    $(document).click(function (event) {
        if ($(event.target).closest(".custom-select").length < 1) {
            $(".select-box").removeClass("active");
        }
    });

    // 

    $('.owl-carousel.certified-slider-2').owlCarousel({
        loop: true,
        margin: 30,
        responsiveClass: true,
        responsive: {
            0: {
                items: 1,
                nav: true
            },
            767: {
                items: 2,
                nav: true
            },
            991: {
                items: 3,
                nav: true
            },
            1024: {
                items: 3,
                nav: true,
                loop: true
            }
        }
    })
    $('.owl-carousel.certified-slider').owlCarousel({
        loop: true,
        margin: 30,
        responsiveClass: true,
        responsive: {
            0: {
                items: 1,
                nav: true
            },
            767: {
                items: 2,
                nav: true
            },
            991: {
                items: 3,
                nav: true
            },
            1024: {
                items: 4,
                nav: true,
                loop: true
            }
        }
    })
    $('.owl-carousel.product-slider-innar').owlCarousel({
        loop: false,
        margin: 30,
        items: 3,
        nav: false,
        responsiveClass: true,
        responsive: {
            0: {
                items: 1,
                nav: true
            },
            767: {
                items: 2,
                nav: true
            },
            991: {
                items: 3,
                nav: true
            },
            1024: {
                items: 4,
                nav: true,
                loop: true
            }
        }
    })
    $('.owl-carousel.wesite-slider').owlCarousel({
        loop: true,
        margin: 30,
        responsiveClass: true,
        responsive: {
            0: {
                items: 1,
                nav: true
            },
            450: {
                items: 2,
                nav: true
            },
            767: {
                items: 3,
                nav: false
            },
            991: {
                items: 3,
                nav: true
            },
            1024: {
                items: 5,
                nav: true,
                loop: false
            }
        }
    })

    $(function () {
        if ($(window).width() <= 1200) {
            $('.customers-main .owl-carousel').owlCarousel({
                loop: true,
                margin: 30,
                responsiveClass: true,
                responsive: {
                    0: {
                        items: 1,
                        nav: true
                    },
                    767: {
                        items: 2,
                        nav: false
                    },
                    991: {
                        items: 3,
                        nav: true
                    },
                    1024: {
                        items: 5,
                        nav: true,
                        loop: true
                    },
                    1200: {
                        items: 5,
                        nav: true,
                        loop: true
                    }
                }
            })
        }

        if ($('.customers-main .item').length > 5) {
            $('.customers-main .owl-carousel').owlCarousel({
                loop: true,
                margin: 30,
                responsiveClass: true,
                responsive: {
                    0: {
                        items: 1,
                        nav: true
                    },
                    767: {
                        items: 2,
                        nav: false
                    },
                    991: {
                        items: 3,
                        nav: true
                    },
                    1024: {
                        items: 5,
                        nav: true,
                        loop: true
                    }
                }
            })
        }
    })

    $(function () {
        if ($(window).width() <= 1200) {
            $('.blog-main .owl-carousel').owlCarousel({
                loop: true,
                margin: 30,
                responsiveClass: true,
                responsive: {
                    0: {
                        items: 1,
                        nav: true
                    },
                    767: {
                        items: 2,
                        nav: true
                    },
                    1024: {
                        items: 3,
                        nav: true,
                        loop: false
                    },
                    1200: {
                        items: 3,
                        nav: true,
                        loop: true
                    }
                }
            })
        }
        if ($('.blog-main .owl-carousel .item').length > 3) {
            $('.blog-main .owl-carousel').owlCarousel({
                loop: true,
                margin: 30,
                responsiveClass: true,
                responsive: {
                    0: {
                        items: 1,
                        nav: true
                    },
                    767: {
                        items: 2,
                        nav: true
                    },
                    1024: {
                        items: 3,
                        nav: true,
                        loop: false
                    }
                }
            })
        }

    })
    $(function () {
        if ($(window).width() <= 1200) {
            $('.instagram-main .owl-carousel').owlCarousel({
                loop: true,
                margin: 30,
                responsiveClass: true,
                dots:false,
                responsive: {
                    0: {
                        items: 1,
                        nav: false
                    },
                    767: {
                        items: 2,
                        nav: false
                    },
                    1024: {
                        items: 3,
                        nav: false,
                        loop: false
                    },
                    1200: {
                        items: 4,
                        nav: false,
                        loop: true
                    }
                }
            })
        }
        if ($('.instagram-main .owl-carousel .item').length > 4) {
            $('.instagram-main .owl-carousel').owlCarousel({
                loop: true,
                margin: 30,
                responsiveClass: true,
                dots:false,
                responsive: {
                    0: {
                        items: 1,
                        nav: false
                    },
                    767: {
                        items: 2,
                        nav: false
                    },
                    1024: {
                        items: 4,
                        nav: false,
                        loop: false
                    }
                }
            })
        }

    })



    $('.owl-carousel.our-product-slider').owlCarousel({
        loop: true,
        margin: 30,
        responsiveClass: true,
        responsive: {
            0: {
                items: 1,
                nav: true
            },
            767: {
                items: 2,
                nav: true
            },
            1024: {
                items: 2,
                nav: true,
                loop: false
            }
        }
    })


    $(function () {
        if ($(window).width() <= 1024) {
            $('.eco-friendly-slide.owl-carousel').owlCarousel({
                loop: true,
                margin: 30,
                responsiveClass: true,
                responsive: {
                    0: {
                        items: 1,
                        nav: true
                    },
                    767: {
                        items: 3,
                        nav: true
                    },
                    1024: {
                        items: 4,
                        nav: true,
                        loop: false
                    }
                }
            })
        }
        if ($('.eco-friendly-slide .item').length > 5) {
            $('.eco-friendly-slide.owl-carousel').owlCarousel({
                loop: true,
                margin: 30,
                responsiveClass: true,
                responsive: {
                    0: {
                        items: 1,
                        nav: true
                    },
                    767: {
                        items: 3,
                        nav: true
                    },
                    1024: {
                        items: 5,
                        nav: true,
                        loop: false
                    }
                }
            })
        }
    });

    $('.bestdeal-slide.owl-carousel').owlCarousel({
        loop: true,
        margin: 30,
        responsiveClass: true,
        responsive: {
            0: {
                items: 1,
                nav: true
            },
            767: {
                items: 2,
                nav: true
            },
            1024: {
                items: 4,
                nav: true,
                loop: true
            }
        }
    })


    $(".dropdown").hover(function () {
        $(this).toggleClass("show");
    });

    $('.search-main-icon').on('click', function () {
        $('.search-main').removeClass('show');
        $('.search-main').addClass('show');
    });
    $('.search-bar a').on('click', function () {
        $('.search-main').removeClass('show');
    });
    // Modal Popup

    //FAQ
    const faqHeaders = document.querySelectorAll('.faqAccordion__header');
    const faqContents = document.querySelectorAll('.faqAccordion__content');
    if (faqHeaders.length > 0) {
      gsap.set(faqContents, { height: 0 });
      gsap.set(faqContents[0], { height: 'auto' });
      faqHeaders[0].classList.add('is-active');
  
      faqHeaders.forEach((faqHeader) => {
        faqHeader.addEventListener('click', function () {
            let faqContent = faqHeader.nextElementSibling;
            if (faqHeader.classList.contains('is-active')) {
                gsap.to(faqContent, { height: 0 });
                faqHeader.classList.remove('is-active');
            } else {
                const activeHeader = document.querySelector('.faqAccordion__header.is-active');
                let delay = 0;
                if (activeHeader) {
                    gsap.to(activeHeader.nextElementSibling, { height: 0 });
                    activeHeader.classList.remove('is-active');
                    delay = .5;
                }
                gsap.timeline().to(faqContent, {
                    height: 'auto',
                    delay: delay
                }).add(() => {
                    faqHeader.classList.add('is-active')
                }, '-=.5')
            }
        });
    });
    }

    //Map popup mobile
    $(".modal-popup").click(function () {
        $("#popup-bg").css("display", "block");
        $("#popup-main").css("display", "block");
    });
    $(".cancel, .modal-bg").click(function () {
        $("#popup-bg").css("display", "none");
        $("#popup-main").css("display", "none");
    });


    // $.post('/cart/update.js', { attributes: { "GiftMassage": `${document.querySelector("#GiftMessage").value}`, "Shipping Date": `${document.querySelector("#shippingDatePicker > input.pickadate").value}` } });


    //mobile location
    if(document.querySelector('.mobile .location-main')){
        document.querySelectorAll('.mobile .location-main').forEach(function(element){
            // console.log(element)
            element.addEventListener('click', _SlowModal.bind(this))
        })

        function _SlowModal(e){
            // console.log(e.currentTarget)
            var location_index = e.currentTarget.getAttribute('data-location-mobile')
            console.log(location_index)
            console.log(document.querySelector(`[data-show-location='${location_index}']`))
            document.querySelectorAll('[data-show-location]').forEach(function(element){
                element.style.display = 'none';
            })
            document.querySelector(`[data-show-location='${location_index}']`).style.display = 'block';
        }
    }

});